export default "__VITE_ASSET__ec4659f0__"